import * as React from "react";
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Form, { FormComponentProps } from 'antd/lib/form/Form';
import { PbrCard } from 'src/components/common/PbrCard/PbrCard';
import StandardButton from 'src/components/common/StandardButton/StandardButton';
import { ExpenseCreateOrEdit } from 'src/components/common/ExpenseCreateOrEdit/ExpenseCreateOrEdit';

const RequestExpensePage = (props: RouteComponentProps<any> & FormComponentProps) => {
  return (
    <PbrCard className="nf-payment" title="Pagamentos solicitados" bordered={false} style={{ width: "100%" }}>
      <ExpenseCreateOrEdit
        title="Solicitação de Pagamento de NF"
        onExecuteText="Solicitar Pagamento"
        forms={props.form}
        buttonToReturn={(
          <StandardButton preset="outline" onClick={props.history.goBack}>
            Voltar
          </StandardButton>
        )}
        isCreate
      />
    </PbrCard>
  );
}

export default withRouter(Form.create()(RequestExpensePage));



// WEBPACK FOOTER //
// ./src/pages/expenses/RequestExpense/RequestExpense.page.tsx